import React, { useEffect, useState } from "react";
import ProductDetails from "./component";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
const ProductDetailsContainer = () => {
    const { makeApiRequest } = useApiRequest()
  const { mv_id, machine_id, slot_id } = useParams();

  const [imagePaths, setImagePaths] = useState([]);
  const [productDetailsData, setProductDetailsData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [similarProduct, setSimilarProduct] = useState([]);
  const [preMachineID, setPreMachineID] = useState(null);
  const [cartItemsList, setCartItemsList] = useState([]);
  const [cartItemsList1, setCartItemsList1] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [countProduct, setCountProduct] = useState(0);
  const [addThisSlot, setAddThisSlot] = useState(null);
  const [replaceCard, setReplaceCard] = useState(false);

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  useEffect(() => {
    fetchProductDetails();
    fetchBuyAgain();
    fetchPreCart();
  }, []);

  // -------------------- API Calls --------------------
  const fetchProductDetails = () => {
    if (!token) return;

    makeApiRequest({
   
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/machine/item-details?mvId=${mv_id}&machineId=${machine_id}&slotId=${slot_id}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => {
        setImagePaths(res.data.data.image_paths || []);
        setProductDetailsData(res.data.data || null);
      },
      handleError: (error) => {
        console.error("Error fetching product details:", error);
      },
    });
  };

  const fetchBuyAgain = () => {
    if (!token) return;

    makeApiRequest({
    
      
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/${machine_id}/items?sort_by=slot&sort_order=asc&exclude_inactive=false&price_min=0&price_max=250&category_id_arr=5`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => {
        const updatedArray = res.data.data.map(item => ({ ...item, mycount: 0 }));
        setSimilarProduct(updatedArray);
      },
      handleError: (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.removeItem("UserJWTAuth");
        } else {
          setLoader(false);
        }
      },
    });
  };

  const fetchPreCart = () => {
    if (!token) return;

    makeApiRequest({
     
      url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => {
        setPreMachineID(res.headers.machineid);
        setCartItemsList(res.data.data.items || []);
        setCountProduct(res.data.data.items.reduce((sum, item) => sum + item.count, 0));
        setTotalAmount(res.data.data.items.reduce((total, item) => total + item.count * item.amount, 0));
      },
      handleError: (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.removeItem("UserJWTAuth");
        } else {
          toast.error(`${error.response?.data.status.code}`, {
           position: "top-right",
            autoClose: 1000,
          });
        }
      },
    });
  };

  // -------------------- Cart Actions --------------------
  const AddIntoCart = ({ e, i, sId, myCartcount, machine_id, replace }) => {
    setAddThisSlot({ sId, index: i });
    setLoader(true);

    const payloadcount = myCartcount >= 0 ? parseInt(myCartcount) + 1 : 1;

    makeApiRequest({
    
    
    url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machine_id}&replace-cart=${replace}`,
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: [{
        slotId: sId,
        count: payloadcount,
      }],
      handleSuccess: (res) => handleResponseAddIntoCart(res, sId),
      handleError: (res) => handleErrorAddIntoCart(res, sId),
    });
  };

  const handleResponseAddIntoCart = (res, sId) => {
    localStorage.setItem("cart_id", res.headers["cart-id"]);
    setLoader(false);
    setCartItemsList1(res.data.data.items || []);
    fetchPreCart();
  };

  const handleErrorAddIntoCart = (res, slotId) => {
    setLoader(false);
    const message = res.response?.data.status.message || "Something went wrong";
    toast.error(message, { position: "top-right", autoClose: 1000 });

    if (message === "Cart contains items from another machine") {
      setReplaceCard(true);
    }
  };

  const RemoveFromCart = (e, sId, myCartcount, machineId) => {
    if (myCartcount === 0) return;
    setLoader(true);

    makeApiRequest({
    
      url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}`,
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: [{
        slotId: parseInt(sId),
        count: myCartcount - 1,
      }],
      handleSuccess: (res) => handleResponseRemoveFromCart(res),
      handleError: (res) => {
        setLoader(false);
        toast.error(`${res}`, { position: "top-right",autoClose: 1000 });
      },
    });
  };

  const handleResponseRemoveFromCart = (res) => {
    setLoader(false);
    setCartItemsList1(res.data.data.items || []);
    fetchPreCart();
  };

  const replaceMyCard = () => {
    setReplaceCard(false);
    fetchPreCart();
    if (addThisSlot) {
      AddIntoCart({ e: null, i: addThisSlot.index, sId: addThisSlot.sId, myCartcount: 0, machine_id, replace: true });
    }
  };

  return (
    <ProductDetails
      imagePaths={imagePaths}
      productDetailsData={productDetailsData}
      AddIntoCart={AddIntoCart}
      similarProduct={similarProduct}
      PreMachineID={preMachineID}
      cartItemsList={cartItemsList}
      RemovefromCart={RemoveFromCart}
      setCartItemsList={setCartItemsList}
      totalAmount={totalAmount}
      countProduct={countProduct}
      replaceCard={replaceCard}
      setReplceCard={setReplaceCard}
      replaceMyCard={replaceMyCard}
    />
  );
};

export default ProductDetailsContainer;
